export const getPublicBucketUrl = (appEnv) => {
    switch (appEnv) {
        case 'production':
            return 'https://cdn.govinity.com';
        case 'staging':
            return 'https://cdn.staging.govinity.io';
        case 'integration':
            return 'https://cdn.integration.govinity.io';
        case 'development':
        case 'preview':
        case 'test':
        default:
            return 'https://cdn.local-dev.govinity.io';
    }
};
